module.exports = __webpack_public_path__ + "static/media/AB_R4_3.ac8b3311.jpg";